import { cdnTemplate } from 'cdnPreprocessor';

export default function ChangeAddress () {
  return {
    restrict: 'E',
    scope: {
      index: '=',
      orderObject: '='
    },
    templateUrl: cdnTemplate('/change-address.html'),
    controller: 'changeAddressCtrl',
    controllerAs: 'address',
    bindToController: true,
    link: (scope, el, attrs, ctrl) => {
      scope.$on('show:changeAddress', (e, index) => ctrl.show(e, index));
    }
  }
};



// WEBPACK FOOTER //
// ./source/client/layout-components/change-address/change-address.dir.js